import {Component} from '@angular/core';

@Component({
  selector: 'app-shopper',
  templateUrl: 'shopperPsycologhy.component.html'
})

export class ShopperPsycologhyComponent {}



// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/shopperPsycologhy/shopperPsycologhy.component.ts